import React from "react"
import PropTypes from "prop-types"
import { Flex } from "antd"
import { useTranslation } from "react-i18next"
import Counter from "ui/Counter"
import PanelSection from "./PanelSection"
import styles from "./BookingPanel.module.css"

// "Total Guests · Up to 5": how many places the ticketed booking holds. The tickets below are then
// shared out between those places.
const TotalGuestsSection = ({ value, maxGuests, onChange, error }) => {
  const { t } = useTranslation()

  return (
    <PanelSection error={error}>
      <Flex align="center" justify="space-between" gap={12}>
        <Flex vertical>
          <span className={styles.sectionTitleStrong}>{t("booking_widget.experience.total_guests")}</span>
          {maxGuests > 0 && <span className={styles.sectionCaption}>{t("booking_widget.experience.total_guests_up_to", { count: maxGuests })}</span>}
        </Flex>
        <Counter
          value={value}
          decreaseLabel={t("booking_widget.experience.fewer_guests")}
          increaseLabel={t("booking_widget.experience.more_guests")}
          isDecreaseDisabled={value <= 0}
          isIncreaseDisabled={maxGuests > 0 && value >= maxGuests}
          onChange={onChange}
        />
      </Flex>
    </PanelSection>
  )
}

TotalGuestsSection.propTypes = {
  value: PropTypes.number.isRequired,
  maxGuests: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string
}

TotalGuestsSection.defaultProps = {
  maxGuests: 0,
  error: null
}

export default TotalGuestsSection
